import React from 'react';
import { linkRowTransitionId, links } from '../../Model/links';
import LinkRow from './LinkRow';
import styles from './LinksView.module.css';

const ROW_STAGGER_IN_MS = 72;

export interface LinksViewProps {
    phase: 'in' | 'out';
    transitionToken: number;
    onHideComplete: (id: string, token: number) => void;
}

const LinksView: React.FC<LinksViewProps> = ({ phase, transitionToken, onHideComplete }) => {
    return (
        <div className={styles.list}>
            {links.map((link, index) => (
                <LinkRow
                    key={linkRowTransitionId(index)}
                    link={link}
                    transitionId={linkRowTransitionId(index)}
                    staggerInMs={index * ROW_STAGGER_IN_MS}
                    phase={phase}
                    transitionToken={transitionToken}
                    onHideComplete={onHideComplete}
                />
            ))}
        </div>
    );
};

export default LinksView;
